/* global axios */
import ApiClient from './ApiClient';

class UserAccessLogsAPI extends ApiClient {
  constructor() {
    super('user_access_logs', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  summary(params = {}) {
    return axios.get(`${this.url}/summary`, { params });
  }
}

export default new UserAccessLogsAPI();
